import React, {Component} from 'react';
import PropTypes from 'prop-types';

class CommesseSelectTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.commessa
        return (
            <tr>
                <td className="pointer selectable" onClick={() => this.props.onCommessaSelect(c)} style={{padding: "0.1em"}}>
                    <p className="ui image content">
                        <label className="ui empty circular label" style={{backgroundColor: c.colore, marginRight: "5px"}}></label>{c.codice} {c.nome} [{c.idCommessa}]
                    </p>
                </td>
            </tr>)
    }
}

CommesseSelectTableRow.PropTypes = {
    onCommessaSelect: PropTypes.func.isRequired
}

export default CommesseSelectTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseSelectTableRow.js
 **/